// Builds the "คัดลอกตะกร้า" chat message and copies it to the clipboard.
// The message is human-readable (a bullet list) PLUS a short "รหัสตะกร้า" code
// from a server snapshot — when the customer pastes it into the shop's chat the
// bot resolves that code to the exact cart and creates the order deterministically.

import type { CartItem } from '@/../types/sale-page'

export async function copyCartToClipboard(
  shopId: string,
  salePageId: string | undefined,
  items: CartItem[],
): Promise<boolean> {
  if (!items.length) return false

  const lines = items.map((i) => `• ${i.name} x${i.quantity}`).join('\n')
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0)

  // Ask the server to snapshot the cart → short code. Best-effort: if it fails
  // we still copy the bullet list (the AI can parse names as a fallback).
  let code = ''
  try {
    const res = await fetch('/api/public/cart-snapshot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopId,
        salePageId: salePageId || null,
        items: items.map((i) => {
          const [productId, variantId] = i.productId.split('__')
          return { productId, variantId: variantId || null, quantity: i.quantity }
        }),
      }),
    })
    if (res.ok) code = (await res.json())?.code || ''
  } catch {
    /* ignore — copy without a code */
  }

  const codeLine = code ? `\n\n🔖 รหัสตะกร้า: ${code}` : ''
  const text = `สนใจสั่งสินค้าตามนี้ 🛒\n${lines}\nรวม ${total.toLocaleString()}฿${codeLine}`

  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
